import React from "react";

const PATHS = {
  shield: (
    <path d="M12 2 4 5v6c0 5 3.6 8.6 8 10 4.4-1.4 8-5 8-10V5l-8-3Z" strokeLinejoin="round" />
  ),
  shieldCheck: (
    <>
      <path d="M12 2 4 5v6c0 5 3.6 8.6 8 10 4.4-1.4 8-5 8-10V5l-8-3Z" strokeLinejoin="round" />
      <path d="M8.5 12.2 11 14.7l4.8-5.4" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  chevronDown: <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />,
  chevronRight: <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />,
  chevronLeft: <path d="M15 6l-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />,
  bell: (
    <path
      d="M6 8a6 6 0 1 1 12 0c0 3 1 4.5 2 6H4c1-1.5 2-3 2-6Z M9.5 19a2.5 2.5 0 0 0 5 0"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  check: <path d="M5 12.5 9.5 17 19 6.5" strokeLinecap="round" strokeLinejoin="round" />,
  lock: (
    <>
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V7.5A4 4 0 0 1 16 7.5V11" strokeLinecap="round" />
    </>
  ),
  trophy: (
    <>
      <path d="M7 4h10v5a5 5 0 0 1-10 0V4Z" strokeLinejoin="round" />
      <path d="M7 5H4v2a3 3 0 0 0 3 3M17 5h3v2a3 3 0 0 1-3 3" strokeLinecap="round" />
      <path d="M12 14v3M9 20h6M9.5 17h5" strokeLinecap="round" />
    </>
  ),
  gift: (
    <>
      <rect x="4" y="9.5" width="16" height="10.5" rx="1.5" />
      <path d="M4 12.5h16M12 9.5v10.5" />
      <path d="M12 9.5C9.5 9.5 8 8 8 6.3A2.3 2.3 0 0 1 12 5c0 .5 0 4.5 0 4.5ZM12 9.5c2.5 0 4-1.5 4-3.2A2.3 2.3 0 0 0 12 5" strokeLinejoin="round" />
    </>
  ),
  orders: (
    <>
      <path d="M4 7h16l-1.4 11.2a2 2 0 0 1-2 1.8H7.4a2 2 0 0 1-2-1.8L4 7Z" strokeLinejoin="round" />
      <path d="M8 7V6a4 4 0 0 1 8 0v1" strokeLinecap="round" />
    </>
  ),
  wallet: (
    <>
      <rect x="3.5" y="6.5" width="17" height="12" rx="2" />
      <path d="M3.5 10.5h17M15 14.5h2.5" strokeLinecap="round" />
    </>
  ),
  aov: <path d="M4 19V9M9.5 19V5M15 19v-7M20 19V11" strokeLinecap="round" />,
  calendar: (
    <>
      <rect x="4" y="5.5" width="16" height="15" rx="2" />
      <path d="M4 10h16M8 3v4M16 3v4" strokeLinecap="round" />
    </>
  ),
  arrowRight: <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />,
  arrowLeft: <path d="M19 12H5M11 6l-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />,
  medal: (
    <>
      <circle cx="12" cy="14.5" r="6" />
      <path d="M9 3h6l2 6-5 3-5-3 2-6Z" strokeLinejoin="round" />
    </>
  ),
  blender: (
    <>
      <path d="M8 3h8l-1 8H9L8 3Z" strokeLinejoin="round" />
      <path d="M7.5 11h9l-1.2 8.2a1.8 1.8 0 0 1-1.8 1.5H10.5a1.8 1.8 0 0 1-1.8-1.5L7.5 11Z" strokeLinejoin="round" />
    </>
  ),
  microwave: (
    <>
      <rect x="3" y="6" width="18" height="12" rx="1.5" />
      <rect x="6" y="8.5" width="8" height="7" rx="1" />
      <circle cx="18" cy="10" r="1" />
      <path d="M17 14h2" strokeLinecap="round" />
    </>
  ),
  washingMachine: (
    <>
      <rect x="4" y="3.5" width="16" height="17" rx="2" />
      <path d="M4 7.5h16" />
      <circle cx="12" cy="14" r="4.2" />
      <circle cx="7" cy="5.5" r="0.6" fill="currentColor" stroke="none" />
      <circle cx="9" cy="5.5" r="0.6" fill="currentColor" stroke="none" />
    </>
  ),
  smartphone: (
    <>
      <rect x="7" y="2.5" width="10" height="19" rx="2.2" />
      <path d="M11 19h2" strokeLinecap="round" />
    </>
  ),
  scooter: (
    <>
      <circle cx="6.5" cy="18" r="2.2" />
      <circle cx="17.5" cy="18" r="2.2" />
      <path d="M6.5 18h6l1.5-6h3M12.5 12l2-5h2.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  motorbike: (
    <>
      <circle cx="5.5" cy="17" r="2.6" />
      <circle cx="18.5" cy="17" r="2.6" />
      <path d="M8 17h5l2.5-6H19M12 11h5l2 3M9 8h4" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  plane: (
    <path
      d="M3 13.5 21 7l-6 6 1.5 6.5-3-3-2 2-1-3.5-3.5-1 2-2-3-3Z"
      strokeLinejoin="round"
    />
  ),
  sparkle: (
    <path d="M12 3l1.8 5.6L19 10l-5.2 1.4L12 17l-1.8-5.6L5 10l5.2-1.4L12 3Z" strokeLinejoin="round" />
  ),
  close: <path d="M6 6l12 12M18 6 6 18" strokeLinecap="round" strokeLinejoin="round" />,
  pill: (
    <>
      <rect x="4.5" y="9.5" width="15" height="8.5" rx="4.25" transform="rotate(-40 12 13.75)" />
      <path d="M9.2 15.7 14.8 10" strokeLinecap="round" />
    </>
  ),
  box: (
    <>
      <path d="M4 8.5 12 4l8 4.5-8 4.5-8-4.5Z" strokeLinejoin="round" />
      <path d="M4 8.5V16l8 4.5 8-4.5V8.5M12 13v7.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  leaf: (
    <>
      <path d="M6 19c-1.5-6.5 1.5-13 12-14 1 10.5-5.5 13.5-12 14Z" strokeLinejoin="round" />
      <path d="M8 17c2-3 4.5-6 9.5-11" strokeLinecap="round" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8.5" r="3" />
      <path d="M3.5 19c0-3.3 2.5-5.5 5.5-5.5s5.5 2.2 5.5 5.5" strokeLinecap="round" />
      <circle cx="17.5" cy="9.5" r="2.4" />
      <path d="M15.8 13.7c2.4.2 4.2 2.2 4.2 5.3" strokeLinecap="round" />
    </>
  ),
  crown: (
    <path
      d="M4 9l3.5 3L12 6l4.5 6L20 9l-1.6 9H5.6L4 9Z"
      strokeLinejoin="round"
    />
  ),
  heater: (
    <>
      <rect x="7" y="3" width="10" height="18" rx="4" />
      <path d="M9.5 8h5M9.5 12h5M9.5 16h5" strokeLinecap="round" />
    </>
  ),
  iron: (
    <>
      <path
        d="M4 17.5 6 10c.6-2.4 2.7-4 5.2-4H16a4 4 0 0 1 4 4v1.5c0 3.3-2.7 6-6 6H4Z"
        strokeLinejoin="round"
      />
      <path d="M4 17.5h16M8.5 6.5V4" strokeLinecap="round" />
    </>
  ),
  ladder: (
    <>
      <path d="M7 3 5 21M17 3l-2 18" strokeLinecap="round" />
      <path d="M5.6 7h11.8M5 12h12.4M4.4 17h11.8" strokeLinecap="round" />
    </>
  ),
  cooler: (
    <>
      <rect x="4" y="4" width="16" height="14" rx="2" />
      <path d="M4 9h16M9 4v5M15 4v5" strokeLinecap="round" />
      <path d="M8 21h1M15 21h1" strokeLinecap="round" />
    </>
  ),
  download: (
    <path
      d="M12 3v12M7 10l5 5 5-5M5 21h14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  bolt: (
    <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" strokeLinejoin="round" />
  ),
  rocket: (
    <>
      <path
        d="M12 3c3 1 5.5 3.5 6.5 6.5C19.5 13 18 17 14.5 20l-1-4-4-1-4 4-1-5c-2-2-3-5.5-1-9 1.5-1.5 4-2.5 8.5-1.5Z"
        strokeLinejoin="round"
      />
      <circle cx="13" cy="9" r="1.6" />
    </>
  ),
  bulb: (
    <>
      <path
        d="M12 3a6 6 0 0 0-3.5 10.9c.7.5 1.1 1.3 1.1 2.1h4.8c0-.8.4-1.6 1.1-2.1A6 6 0 0 0 12 3Z"
        strokeLinejoin="round"
      />
      <path d="M9.5 19h5M10.3 21.5h3.4" strokeLinecap="round" />
    </>
  ),
};

const Icon = ({
  name,
  size = 20,
  color = "currentColor",
  strokeWidth = 1.8,
  filled = false,
  style,
  ...rest
}) => {
  const path = PATHS[name];
  if (!path) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? color : "none"}
      stroke={color}
      strokeWidth={strokeWidth}
      style={style}
      {...rest}>
      {path}
    </svg>
  );
};

export default Icon;
